import React from "react";
import { Send, Users, MessageCircleMore, ChevronRight } from "lucide-react";
import PageLayout from "../components/PageLayout";
import { BRAND, BRAND_BG, BRAND_BORDER, cardBase } from "../theme/colors";

const ContactsPage: React.FC = () => {
  const items = [
    {
      icon: Send,
      title: "Telegram kanal",
      subtitle: "@pravaTest_2026 — yangiliklar va testlar",
      url: "https://t.me/pravaTest_2026",
    },
    {
      icon: Users,
      title: "Chat guruh",
      subtitle: "@pravaTest_26 — savol-javob, suhbat",
      url: "https://t.me/pravaTest_26",
    },
    {
      icon: MessageCircleMore,
      title: "Taklif va shikoyatlar",
      subtitle: "@erkayev_murod — admin bilan bog'lanish",
      url: "https://t.me/erkayev_murod",
    },
  ];

  return (
    <PageLayout title="Aloqa va kanallar" subtitle="Bizga qo'shiling">
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <a
              key={item.url}
              href={item.url}
              target="_blank"
              rel="noreferrer"
              style={{
                ...cardBase,
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "14px 16px",
                textDecoration: "none",
                transition: "all .2s",
              }}
              onMouseEnter={(e) => {
                const el = e.currentTarget as HTMLElement;
                el.style.borderColor = BRAND;
                el.style.background = BRAND_BG;
              }}
              onMouseLeave={(e) => {
                const el = e.currentTarget as HTMLElement;
                el.style.borderColor = "var(--border)";
                el.style.background = "var(--card)";
              }}>
              <div
                style={{
                  width: 38,
                  height: 38,
                  borderRadius: 8,
                  background: BRAND_BG,
                  border: `1px solid ${BRAND_BORDER}`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <Icon size={18} style={{ color: BRAND }} />
              </div>
              <div style={{ flex: 1 }}>
                <p style={{ color: "#fff", fontWeight: 700, fontSize: 14 }}>
                  {item.title}
                </p>
                <p
                  style={{
                    color: "var(--muted)",
                    fontSize: 11,
                    marginTop: 2,
                  }}>
                  {item.subtitle}
                </p>
              </div>
              <ChevronRight size={16} style={{ color: "var(--muted)" }} />
            </a>
          );
        })}
      </div>
    </PageLayout>
  );
};

export default ContactsPage;
